document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.gx-header');
  const mega = document.querySelector('[data-mega-menu]');
  const backdrop = document.querySelector('[data-mega-backdrop]');
  const triggers = Array.from(document.querySelectorAll('[data-mega-trigger]'));
  const panels = Array.from(document.querySelectorAll('[data-mega-panel]'));
  if (!header || !mega || !backdrop || !triggers.length) return;

  const positionMega = () => {
    mega.style.top = `${Math.round(header.getBoundingClientRect().bottom)}px`;
  };
  const updateStickyHeader = () => {
    header.classList.toggle('is-sticky', window.scrollY > 90);
    if (mega.classList.contains('is-open')) positionMega();
  };
  updateStickyHeader();
  window.addEventListener('scroll', updateStickyHeader, { passive: true });

  let closeTimer;
  const clearCloseTimer = () => window.clearTimeout(closeTimer);
  const close = () => {
    clearCloseTimer();
    mega.classList.remove('is-open');
    backdrop.classList.remove('is-active');
    header.classList.remove('is-mega-open');
    mega.setAttribute('aria-hidden', 'true');
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    panels.forEach((panel) => panel.classList.remove('is-active'));
  };
  const open = (name) => {
    clearCloseTimer();
    const targetPanel = panels.find((panel) => panel.dataset.megaPanel === name);
    if (!targetPanel) return;
    panels.forEach((panel) => panel.classList.toggle('is-active', panel === targetPanel));
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(trigger.dataset.megaTrigger === name)));
    mega.classList.add('is-open');
    positionMega();
    backdrop.classList.add('is-active');
    header.classList.add('is-mega-open');
    mega.setAttribute('aria-hidden', 'false');
  };
  const scheduleClose = () => { closeTimer = window.setTimeout(close, 180); };

  triggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => open(trigger.dataset.megaTrigger));
    trigger.addEventListener('focus', () => open(trigger.dataset.megaTrigger));
    trigger.addEventListener('click', () => {
      if (trigger.getAttribute('aria-expanded') === 'true') close();
      else open(trigger.dataset.megaTrigger);
    });
  });
  header.addEventListener('mouseleave', scheduleClose);
  mega.addEventListener('mouseenter', clearCloseTimer);
  mega.addEventListener('mouseleave', scheduleClose);
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
});
